import { SanityImageSource } from '@sanity/image-url/lib/types/types'

import { SanityImage } from 'src/components/atoms/SanityImage'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'
import { ImageHeadingTextRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'
import { Text, TextValue } from 'src/components/molecules/sanity/Content'

export type ImageHeadingTextSectionRebrandProps = Omit<
  ImageHeadingTextRebrandResult,
  'heading' | 'text' | 'image'
> & {
  heading?: TextValue
  text?: TextValue
  image?: SanityImageSource
}

const ImageHeadingTextSectionRebrand = ({
  heading,
  text,
  image
}: ImageHeadingTextSectionRebrandProps) => (
  <section className='relative isolate overflow-hidden'>
    zxcv
    {image && (
      <SanityImage alt='' source={image} fill className='-z-20 object-cover' />
    )}
    <div className='absolute inset-0 -z-10 bg-black/25' />
    <div className='container mx-auto px-4 py-16 lg:px-20 lg:py-24'>
      <div className='grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-16'>
        {heading && (
          <div className='lg:col-span-2'>
            <TypographyRebrand variant='h1' as='h2' color='limeBright'>
              <Text
                components={{
                  block: ({ children }) => (
                    <span className='block'>{children}</span>
                  )
                }}
                value={heading}
              />
            </TypographyRebrand>
          </div>
        )}
        {text && (
          <div className='[&_a]:underline'>
            <TypographyRebrand variant='introduction' color='white'>
              <Text
                components={{
                  block: ({ children }) => (
                    <p className='mb-4 last:mb-0'>{children}</p>
                  )
                }}
                value={text}
              />
            </TypographyRebrand>
          </div>
        )}
      </div>
    </div>
  </section>
)

export default ImageHeadingTextSectionRebrand
